import {
  SUPPRESSED_SHORTFALL_LIST_ERROR,
  SUPPRESSED_SHORTFALL_LIST_RECEIVED,
  SUPPRESSED_SHORTFALL_LIST_REQUEST,
  SUPPRESSED_SHORTFALL_LIST_SET_PAGE,
  SUPPRESSED_SHORTFALL_LIST_UNLOAD,
} from '../constants';

import { hydraPageCount } from '../../helper/apiUtils';

/**
 * MED-1002 - the Suppressed Shortfalls list.
 *
 * Follows the patients reducer, minus the filters it has no screen for. `hasLoaded` is separate
 * from `isFetching` so the screen can tell "nothing has been suppressed" from "nothing has been
 * fetched yet" - on this list an empty table is the good outcome and must not be shown before it
 * is true.
 */
const initialState = {
  suppressedShortfalls: [],
  isFetchingSuppressedShortfalls: false,
  hasLoadedSuppressedShortfalls: false,
  currentPage: 1,
  pageCount: null,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUPPRESSED_SHORTFALL_LIST_REQUEST:
      return {
        ...state,
        isFetchingSuppressedShortfalls: true,
      };

    case SUPPRESSED_SHORTFALL_LIST_RECEIVED:
      return {
        ...state,
        suppressedShortfalls: action.data['hydra:member'],
        pageCount: hydraPageCount(action.data),
        isFetchingSuppressedShortfalls: false,
        hasLoadedSuppressedShortfalls: true,
        error: null,
      };

    case SUPPRESSED_SHORTFALL_LIST_ERROR:
      return {
        ...state,
        error: action.error,
        isFetchingSuppressedShortfalls: false,
        hasLoadedSuppressedShortfalls: false,
      };

    case SUPPRESSED_SHORTFALL_LIST_SET_PAGE:
      return {
        ...state,
        currentPage: action.page,
      };

    case SUPPRESSED_SHORTFALL_LIST_UNLOAD:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
